<script setup>
import useCategories from "../../use/useCategories"
import { onUpdated, defineProps, ref, computed, defineEmits, onMounted } from "vue"

import vSelect from "vue-select"
import "vue-select/dist/vue-select.css"

const props = defineProps({
  modelValue: Boolean,
  category: {
    required: true,
    type: Object,
  },
  allCategories: {
    required: true,
    type: Object,
  },
})

const categoryData = ref({
  id: props.category.id,
  parent_id: props.category.parent_id,
  category_parent_name: props.category.category_parent_name,
  category_name: props.category.name,
  category_slug: props.category.slug,
  is_in_menu: props.category.is_in_menu,
  category_image: props.category.image,
})

const emit = defineEmits(["update:modelValue", "close"])

const { show, loading, errors, getAllCategories, onSubmit, closeModal } =
  useCategories(props, emit, categoryData)

onUpdated(() => {
  categoryData.value = {
    id: props.category.id,
    parent_id: props.category.parent_id,
    category_parent_name: props.category.category_parent_name,
    category_name: props.category.name,
    category_slug: props.category.slug,
    is_in_menu: props.category.is_in_menu,
    category_image: props.category.image,
  }
})

const onFileChange = (event) => {
  categoryData.value.category_image = event.target.files[0]
}

onMounted(() => {
  getAllCategories()
})

const levelThreeCategories = computed(() => {
  const categories = props.allCategories.data || []

  const levelThree = categories.filter((category) => {
    const parentCategory = categories.find(
      (parent) => parent.id === category.parent_id
    )
    return parentCategory && parentCategory.parent_id !== null
  })

  return categories.filter((category) => {
    return !levelThree.some((level3) => level3.id === category.id)
  })
})
</script>

<template>
  <!-- edit category modal  -->
  <b-modal
    v-model="show"
    @close="closeModal()"
    id="showModal"
    hide-footer
    title=" ویرایش دسته بندی"
    header-class="p-3 bg-light"
    class="v-modal-custom"
    centered
    no-close-on-backdrop
  >
    <b-overlay
      variant="white"
      opacity="0.75"
      blur="2px"
      :show="loading"
      spinner-variant="success"
      rounded="sm"
    >
      <b-card>
        <b-form
          id="addform"
          class="tablelist-form"
          autocomplete="off"
          @submit.prevent="onSubmit"
          enctype="multipart/form-data"
        >
          <div class="mb-3">
            <label for="name" class="form-label">مادر دسته</label>

            <v-select
              v-model="categoryData.parent_id"
              :options="levelThreeCategories"
              label="name"
              :reduce="(category) => category.id"
              placeholder="جستجوی دسته مادر"
              class="mb-3 v-select-rtl"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.parent_id">
                <span>{{ errors.parent_id[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="name" class="form-label"> نام دسته بندی</label>
            <input
              type="text"
              id="name"
              class="form-control"
              placeholder="نام دسته بندی"
              v-model="categoryData.category_name"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.category_name">
                <span>{{ errors.category_name[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="slug" class="form-label">لینک دسته بندی</label>
            <input
              type="text"
              id="slug"
              class="form-control"
              placeholder="لینک دسته بندی"
              v-model="categoryData.category_slug"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.category_slug">
                <span>{{ errors.category_slug[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="formFile" class="form-label">تصویر دسته بندی</label>
            <input
              class="form-control"
              type="file"
              id="formFile"
              @change="onFileChange"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.category_image">
                <span>{{ errors.category_image[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <img
              class="img-thumbnail"
              alt="categoryData.category_name"
              width="75"
              :src="categoryData.category_image"
              data-holder-rendered="true"
            />
          </div>

          <div class="mb-3">
            <label for="is_in_menu" class="form-label"
              >وضعیت نمایش در منو</label
            >
            <select
              class="form-select"
              id="is_in_menu"
              v-model="categoryData.is_in_menu"
            >
              <option selected>وضعیت</option>
              <option value="0">عدم نمایش</option>
              <option value="1">نمایش</option>
            </select>
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.is_in_menu">
                <span>{{ errors.is_in_menu[0] }}</span>
              </div>
            </div>
          </div>

          <div class="hstack gap-2 justify-content-end">
            <b-button
              type="button"
              id="closemodal"
              variant="light"
              @click="closeModal"
            >
              بستن
            </b-button>
            <b-button type="submit" variant="success"
              >ویرایش دسته بندی</b-button
            >
          </div>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
